export default __webpack_public_path__ + "static/media/DashboardMarjoo.aa4df1da.svg";